export { default as createIntlTagWrapper } from './create-intl-tag-wrapper';
